// extracted by mini-css-extract-plugin
module.exports = {"root":"PlaceholderBox_root__1Dtr3"};